import { Injectable } from '@angular/core';
import { OidcAuthService } from '../../auth/services/oidc-auth.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { filter, map, Observable } from 'rxjs';

@Injectable()
export class RoleService {

  isInRole(roleName: string): boolean {
    if (roleName === MojoWellKnownNames.RoleNames.AnyAdministrator) {
      return this.getRoles().some(r => r.indexOf(roleName) > -1);
    } else {
      return (this.getRoles().includes(roleName));
    }
  }

  isInRoleAsync(roleName: string): Observable<boolean> {
    return this.getRolesAsync().pipe(map(roles => {
      if (roleName === MojoWellKnownNames.RoleNames.AnyAdministrator) {
        return roles.some(r => r.indexOf(roleName) > -1);
      } else {
        return (roles.includes(roleName));
      }
    }));
  }

  hasRolesAsync(roleNames: string[]): Observable<boolean> {
    return this.getRolesAsync().pipe(map(roles => {

      if (roleNames.includes(MojoWellKnownNames.RoleNames.AnyAdministrator))
        if (roles.some(r => r.indexOf(MojoWellKnownNames.RoleNames.AnyAdministrator) > -1))
          return true;

      return roles.some(x=> roleNames.includes(x));
    }));
  }

  contains(roles: string[]): boolean {
    return this.getRoles().some(r => roles && roles.indexOf(r) >= 0);
  }

  hasRoles(roleNames: string[]): boolean {
    const roles = this.getRoles();
    if (roleNames.includes(MojoWellKnownNames.RoleNames.AnyAdministrator))
      if (roles.some(r => r.indexOf(MojoWellKnownNames.RoleNames.AnyAdministrator) > -1))
        return true;

    return roles.some(x=> roleNames.includes(x));

  }

  getRoles(): Array<string> {
    if (!this.authService.isLoggedIn) {
      return [];
    }
    const result = this.authService.getUserProfileImmediate().roles;
    return result;
  }

  getRolesAsync(): Observable<Array<string>> {
    const result = this.authService.getUserProfile().pipe(filter(profile => profile != undefined), map(profile => profile.roles));
    return result;
  }

  constructor(private readonly authService: OidcAuthService) { }

}
